// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_j1-0";
export var discountCodeInput = "_j1-1";